// indexedDb.ts copyright 2021 Rebecca Beaudet
import { openDB } from 'idb';
const DB_NAME = 'db0';
let dbObject = null;
let dbPromise = null;
const currentDbVersion = 1;
// checking for last db version needs to be done after calling db
// in case of upgrade
let lastDbVersion = currentDbVersion;
const freshSetup = (db) => {
    db.createObjectStore('profiles', { keyPath: 'id' });
};
const initDB = async () => {
    try {
        const db0 = await openDB(DB_NAME, currentDbVersion, {
            upgrade(db, oldVersion, newVersion, transaction) {
                lastDbVersion = oldVersion;
                if (oldVersion === 0) {
                    console.log('starting from scratch');
                    freshSetup(db);
                    return;
                }
            },
            blocked() {
                console.log('blocked');
            },
            blocking() {
                console.log('blocking');
            },
            terminated() {
                console.log('terminated');
            },
        });
        dbObject = db0;
        return db0;
    }
    catch (error) {
        console.error(new Error(`IndexDB init: ${error}`));
    }
};
const getDb = async () => {
    if (!dbPromise)
        dbPromise = initDB();
    return dbObject ? dbObject : await dbPromise;
};
export { getDb, currentDbVersion, lastDbVersion, DB_NAME };
